import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-storage-list',
  templateUrl: './storage-list.component.html',
  styleUrls: ['./storage-list.component.css']
})
export class StorageListComponent implements OnInit {

  @Input() adminUsers;

  constructor() { }

  ngOnInit() {
  }

}
